import React, { useCallback } from "react";
import { GameNavButtonGroup, GameNavButtonGroupProps } from "@ugitgud/legos/components/nav/GameNav/GameNavButtonGroup";
import { GameNavButton } from "@ugitgud/legos/components/nav/GameNav/GameNavButton";
import { NavTag } from "@ugitgud/legos/ui/form/tag/NavTag";
import { SvgGameValGrey } from "@ugitgud/legos/ui/icon/SVG/GameValGrey";
import { SvgGameLolGrey } from "@ugitgud/legos/ui/icon/SVG/GameLolGrey";
import { SvgGameLol } from "@ugitgud/legos/ui/icon/SVG/GameLol";
import { SvgGameVal } from "@ugitgud/legos/ui/icon/SVG/GameVal";
import { SvgGameTft } from "@ugitgud/legos/ui/icon/SVG/GameTft";
import { SvgGameWow } from "@ugitgud/legos/ui/icon/SVG/GameWow";
import { SvgGameWowGrey } from "@ugitgud/legos/ui/icon/SVG/GameWowGrey";
import { SvgGameTftGrey } from "@ugitgud/legos/ui/icon/SVG/GameTftGrey";
import { SvgGameHelldiversGrey } from "@ugitgud/legos/ui/icon/SVG/GameHelldiversGrey";
import { SvgGameHelldivers } from "@ugitgud/legos/ui/icon/SVG/GameHelldivers";
import { SvgGame2XkoGrey } from "@ugitgud/legos/ui/icon/SVG/Game2XkoGrey";
import { SvgGame2Xko } from "@ugitgud/legos/ui/icon/SVG/Game2Xko";
import { SvgGameDeadlock } from "@ugitgud/legos/ui/icon/SVG/GameDeadlock";
import { SvgGameDeadlockGrey } from "@ugitgud/legos/ui/icon/SVG/GameDeadlockGrey";
import classNames from "classnames";
import { SvgGameMarvelRivals } from "@ugitgud/legos/ui/icon/SVG/GameMarvelRivals";
import { SvgGameMarvelRivalsGrey } from "@ugitgud/legos/ui/icon/SVG/GameMarvelRivalsGrey";
import { SvgGameSiege } from "@ugitgud/legos/ui/icon/SVG/GameSiege";
import { SvgGameSiegeGrey } from "@ugitgud/legos/ui/icon/SVG/GameSiegeGrey";
import { SvgGameSwarmGrey } from "@ugitgud/legos/ui/icon/SVG/GameSwarmGrey";
import { SvgGameSwarm } from "@ugitgud/legos/ui/icon/SVG/GameSwarm";
import { useSwitchGame } from "@ugitgud/legos/context/bytebrew";
import { SupportedGames } from "@ugitgud/legos/components/util/UggGAEventProvider";

export const GameNav: React.FC<
  Pick<GameNavButtonGroupProps, "selectedGame" | "className"> & { onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void }
> = ({ selectedGame, className, onClick }) => {
  const newCustomEvent = useSwitchGame();
  const callback = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      const href = e.currentTarget.href;
      if (!href) {
        return;
      }
      const url = new URL(e.currentTarget.href);
      const segments = url.pathname.split("/");
      newCustomEvent(segments[1] as SupportedGames);
      onClick?.(e);
    },
    [newCustomEvent],
  );
  return (
    <div
      className={classNames(
        "w-full overflow-x-auto min-h-[31px] h-[31px] font-inter overflow-y-hidden dark:bg-purple-500 pointer-events-auto sb-hide border-b-purple-400 border-b",
        className,
      )}
    >
      <GameNavButtonGroup className={classNames("h-[30px]")} selectedGame={selectedGame}>
        <GameNavButton
          game="lol"
          icon={<SvgGameLolGrey />}
          iconToggled={<SvgGameLol />}
          onClick={callback}
          href="https://u.gg/?utm_source=uggtopnav"
        >
          League of Legends
        </GameNavButton>
        <GameNavButton
          game="val"
          icon={<SvgGameValGrey />}
          iconToggled={<SvgGameVal />}
          onClick={callback}
          href="https://u.gg/val?utm_source=uggtopnav"
        >
          Valorant{" "}
          <NavTag shrink={false} size="sm" colorScheme="primary">
            NEW
          </NavTag>
        </GameNavButton>
        <GameNavButton
          game="marvel-rivals"
          icon={<SvgGameMarvelRivalsGrey />}
          iconToggled={<SvgGameMarvelRivals />}
          onClick={callback}
          href="https://u.gg/marvel-rivals?utm_source=uggtopnav"
        >
          Marvel Rivals{" "}
          <NavTag shrink={false} size="sm" colorScheme="primary">
            New
          </NavTag>
        </GameNavButton>
        <GameNavButton
          game="siege"
          icon={<SvgGameSiegeGrey />}
          iconToggled={<SvgGameSiege />}
          onClick={callback}
          href="https://u.gg/siege?utm_source=uggtopnav"
        >
          Rainbow Six Siege{" "}
          <NavTag shrink={false} size="sm" colorScheme="tertiary">
            SOON™
          </NavTag>
        </GameNavButton>
        <GameNavButton
          game="tft"
          icon={<SvgGameTftGrey />}
          iconToggled={<SvgGameTft />}
          onClick={callback}
          href="https://u.gg/tft?utm_source=uggtopnav"
        >
          Teamfight Tactics{" "}
        </GameNavButton>
        <GameNavButton
          game="deadlock"
          icon={<SvgGameDeadlockGrey />}
          iconToggled={<SvgGameDeadlock />}
          onClick={callback}
          href="https://u.gg/deadlock?utm_source=uggtopnav"
        >
          Deadlock{" "}
          <NavTag shrink={false} size="sm" colorScheme="accent-green">
            BETA
          </NavTag>
        </GameNavButton>
        <GameNavButton
          game="wow"
          icon={<SvgGameWowGrey />}
          iconToggled={<SvgGameWow />}
          onClick={callback}
          href="https://u.gg/wow?utm_source=uggtopnav"
        >
          World of Warcraft
        </GameNavButton>
        <GameNavButton
          game="helldivers"
          icon={<SvgGameHelldiversGrey />}
          iconToggled={<SvgGameHelldivers />}
          onClick={callback}
          href="https://u.gg/hd2?utm_source=uggtopnav"
        >
          Helldivers 2
        </GameNavButton>
        <GameNavButton
          game="2xko"
          icon={<SvgGame2XkoGrey />}
          iconToggled={<SvgGame2Xko />}
          onClick={callback}
          href="https://u.gg/2xko?utm_source=uggtopnav"
        >
          2XKO{" "}
          <NavTag shrink={false} size="sm" colorScheme="tertiary">
            SOON™
          </NavTag>
        </GameNavButton>
      </GameNavButtonGroup>
    </div>
  );
};
